/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { actions } from '../actionTypes';

interface ICommonFilterState {
  halls: string;
  showDetails: boolean;
  showFavourites: boolean;
  show: string;
  searchValue: string;
  showManufacturers: boolean;
}

export const initialCommonFilterState: ICommonFilterState = {
  halls: 'all',
  showDetails: false,
  showFavourites: false,
  show: 'map',
  searchValue: '',
  showManufacturers: true,
};

interface IInitialFilterState {
  initial: ICommonFilterState;
}

export const initialCommonFilterStates: IInitialFilterState = {
  initial: initialCommonFilterState,
};

const commonListFilters = (
  state: IInitialFilterState | undefined = initialCommonFilterStates,
  action: any,
): IInitialFilterState | undefined => {
  switch (action.type) {
    case actions.SET_COMMON_FILTER: {
      const key = `${action.payload.filter.fairTag}`;
      if (state[key]) {
        state[key] = {
          ...state[key],
          ...action.payload.filter,
        };
      } else {
        state[key] = {
          ...state.initial,
          ...action.payload.filter,
        };
      }
      // "Hack", reassignment is necessary, otherwise the storage is not updated.
      return {
        ...state,
        [key]: state[key],
      };
    }

    default: {
      return state;
    }
  }
};

export default commonListFilters;
